import {
  DEFAULT_ACTION_IDENTIFIER,
  clearLastNotificationResponseAsync,
  getLastNotificationResponseAsync,
} from "expo-notifications";
import { Linking } from "react-native";
import { useCallback } from "react";
import { usePushNotificationPayloadStore } from "@src/stores/pushNotificationPayload";
import type { ConcreteOptions } from "./types";

/**
 * Handle the link or push notification that initially opened the app
 *
 * @link https://docs.expo.dev/linking/into-your-app/#handle-urls
 * @link https://docs.expo.dev/versions/latest/sdk/notifications/#handle-push-notifications-with-navigation
 */
export const useGetInitialUrl = () => {
  const setPayloadFromNotificationResponse = usePushNotificationPayloadStore(
    state => state.setPayloadFromNotificationResponse
  );

  const getInitialURL: ConcreteOptions["getInitialURL"] = useCallback(async () => {
    // immediately open the URL if app was opened by a deeplink
    const initialUrl = await Linking.getInitialURL();
    if (initialUrl !== null) {
      return initialUrl;
    }

    // otherwise, check if a push notification opened the app, handle as needed
    const response = await getLastNotificationResponseAsync();
    if (response === null || response.actionIdentifier !== DEFAULT_ACTION_IDENTIFIER) {
      return null;
    }
    await clearLastNotificationResponseAsync();
    setPayloadFromNotificationResponse(response);

    return null;
  }, [setPayloadFromNotificationResponse]);

  return { getInitialURL };
};
